export default {
    upload(file, width, height) {
        let formData = new FormData();
        formData.append('file', file);
        if (width) {
            formData.append('width', width);
        }
        if (height) {
            formData.append('height', height);
        }
        return window.axios.post('/api/upload', formData);
    },

    delete(path) {
        return window.axios.post('/api/upload/delete', {path});
    },

    rotateImage(url) {
        return window.axios.post('/api/upload/rotate', {url});
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/services/UploadService.js